<template>
	<DaModalFrame v-model:open="modalIsOpen">
		<CopyGoal @close="modalIsOpen = false" @submit="copyAllGoal" />
	</DaModalFrame>
	<div class="w-full">
		<div v-if="!studentSelected && !libSelected">
			<div v-if="isLoading">
				<Loading />
			</div>
			<div v-else>
				<div v-if="students && students.length > 0">
					<div class="shadow-sm sm:rounded-2xl overflow-hidden">
						<div class="__record__table overflow-x-auto scroll-bar">
							<div
								class="
									overflow-hidden
									sm:rounded-t-2xl
									w-fit
									min-w-full
								"
							>
								<table
									class="min-w-full divide-y text-neutral-200"
								>
									<thead class="bg-neutral-100 h-16">
										<tr>
											<th
												scope="col"
												class="
													px-6
													py-3
													text-left text-xs
													font-semibold
													text-neutral-600
													uppercase
													tracking-wider
													w-16
													whitespace-nowrap
												"
											>
												STT
											</th>
											<th
												scope="col"
												class="
													px-6
													py-3
													text-left text-xs
													font-semibold
													text-neutral-600
													uppercase
													tracking-wider
													whitespace-nowrap
												"
											>
												Tên học sinh
											</th>
											<th
												scope="col"
												class="
													px-6
													py-3
													text-left text-xs
													font-semibold
													text-neutral-600
													uppercase
													tracking-wider
													whitespace-nowrap
												"
											>
												đánh giá phát triển
											</th>
											<th
												scope="col"
												class="
													px-6
													py-3
													text-left text-xs
													font-semibold
													text-neutral-600
													uppercase
													tracking-wider
													whitespace-nowrap
												"
											>
												Mục tiêu
											</th>
											<th
												scope="col"
												class="
													px-6
													py-3
													text-left text-xs
													font-semibold
													text-neutral-600
													uppercase
													tracking-wider
													whitespace-nowrap
												"
											>
												Lĩnh vực
											</th>
										</tr>
									</thead>
									<tbody>
										<tr
											v-for="(s, i) in students"
											:key="s.id"
											:class="
												i % 2 === 0
													? 'bg-white'
													: 'bg-neutral-50'
											"
											class="
												text-neutral-700
												cursor-pointer
											"
											@click="selectStudent(s)"
										>
											<td
												class="
													px-6
													py-4
													whitespace-nowrap
													text-neutral-700
												"
											>
												<div class="ml-2">
													{{ i + 1 }}
												</div>
											</td>
											<td
												class="
													px-6
													py-4
													text-orange-600
													font-semibold
												"
											>
												{{ s.name }}
											</td>
											<td
												class="
													px-6
													py-4
													text-neutral-700
												"
											>
												{{ s.student_assessment_count }}
											</td>
											<td
												class="
													px-6
													py-4
													text-neutral-700
												"
											>
												{{ s.goal_count }}
											</td>
											<td
												class="
													px-6
													py-4
													text-neutral-700
												"
											>
												{{ s.skill_count }}
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
				<div
					v-else
					class="
						w-full
						h-full
						flex
						items-center
						justify-center
						flex-col
					"
				>
					<img
						src="@/assets/images/illustrations/not_found.png"
						alt=""
						height="250"
						width="250"
					/>
					<div class="text-neutral-600 text-center text-lg">
						Trung tâm chưa có biểu mẫu của học sinh nào khác
					</div>
				</div>
			</div>
		</div>
		<div v-if="studentSelected && !libSelected">
			<div
				class="
					__breadcrumbs
					text-sm text-neutral-500
					font-semibold
					cursor-pointer
					items-center
					mb-6
				"
				@click="studentSelected = null"
			>
				Danh sách học sinh
			</div>
			<div v-if="isLoading">
				<Loading />
			</div>
			<div v-else>
				<div
					class="
						flex
						justify-between
						items-center
						w-full
						md-down:flex-col md-down:items-start
						gap-8
						mb-10
					"
				>
					<div class="flex items-center">
						<!-- <div class="relative">
							<img
								v-if="studentSelected?.profile_photo?.w200"
								:alt="studentSelected?.name"
								:src="studentSelected?.profile_photo?.w200"
								class="
									shadow-sm
									inline-block
									h-14
									w-14
									rounded-full
								"
								style="min-width: 56px"
							/>
							<span
								v-else
								:style="{
									background:
										studentSelected?.profile_photo?.default
											?.color,
								}"
								class="
									inline-flex
									items-center
									justify-center
									h-14
									w-14
									rounded-full
								"
								style="min-width: 56px"
							>
								<span
									class="
										font-medium
										leading-none
										text-white text-4xl
									"
									>{{
										studentSelected?.profile_photo?.default
											?.initial
									}}</span
								>
							</span>
						</div> -->

						<svg
							class="cursor-pointer"
							width="28"
							height="28"
							viewBox="0 0 28 28"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
							@click="studentSelected = null"
						>
							<path
								d="M17.5 7L10.5 14L17.5 21"
								stroke="#94A3B8"
								stroke-width="2"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
						</svg>

						<div class="ml-4">
							<div
								class="
									font-bold
									text-neutral-700 text-4xl
									md-down:text-2xl
								"
							>
								{{ studentSelected?.name }}
							</div>
						</div>
					</div>
				</div>
				<div v-if="listForm.length > 0">
					<div class="flex flex-col">
						<div class="-my-2 sm:-mx-6 lg:-mx-8">
							<div
								class="
									py-2
									align-middle
									inline-block
									min-w-full
									sm:px-6
									lg:px-8
								"
							>
								<div class="shadow sm:rounded-lg">
									<table
										class="
											min-w-full
											divide-y
											text-neutral-200
										"
									>
										<thead class="bg-neutral-100 h-16">
											<tr>
												<th
													scope="col"
													class="
														px-6
														py-3
														text-left text-xs
														font-semibold
														text-neutral-600
														uppercase
														tracking-wider
														whitespace-nowrap
													"
												>
													biểu mẫu
												</th>
												<th
													scope="col"
													class="
														px-6
														py-3
														text-left text-xs
														font-semibold
														text-neutral-600
														uppercase
														tracking-wider
														whitespace-nowrap
													"
												>
													Thư viện sử dụng
												</th>

												<th
													scope="col"
													class="
														px-6
														py-3
														text-left text-xs
														font-semibold
														text-neutral-600
														uppercase
														tracking-wider
														whitespace-nowrap
													"
												>
													NGƯỜI TẠO
												</th>
											</tr>
										</thead>
										<tbody>
											<tr
												v-for="(
													form, index
												) in listForm"
												:key="form.id"
												:class="
													index % 2 === 0
														? 'bg-white'
														: 'bg-neutral-50'
												"
												class="
													hover:bg-orange-50
													cursor-pointer
												"
												@click="selectLib(form.id)"
											>
												<td
													class="
														px-6
														py-4
														text-neutral-700
														whitespace-nowrap
													"
												>
													<div
														class="
															flex
															items-center
															gap-2
														"
													>
														<img
															class="w-5 h-5"
															src="@/assets/images/icons/form-evaluation.png"
															alt=""
														/>
														<div>
															{{ form.name }}
														</div>
													</div>
												</td>
												<td
													class="
														px-6
														py-4
														text-neutral-700
													"
												>
													<div
														class="
															flex flex-col
															gap-
														"
													>
														<div
															v-for="(
																l, lIndex
															) in form.goal_library_names"
															:key="lIndex"
														>
															- {{ l }}
														</div>
													</div>
												</td>
												<td
													class="
														px-6
														py-4
														text-neutral-700
													"
												>
													<div>
														<div
															v-if="
																form.created_by_staff
															"
															class="
																flex
																items-center
																mb-4
															"
														>
															<div>
																<img
																	v-if="
																		form
																			.created_by_staff
																			?.profile_photo
																			?.w200
																	"
																	:src="
																		form
																			.created_by_staff
																			?.profile_photo
																			?.w200
																	"
																	alt=""
																	class="
																		shadow-sm
																		inline-block
																		h-9
																		w-9
																		rounded-full
																	"
																/>
																<span
																	v-else
																	:style="{
																		background:
																			form
																				.created_by_staff
																				?.profile_photo
																				?.default
																				?.color,
																	}"
																	class="
																		inline-flex
																		items-center
																		justify-center
																		h-9
																		w-9
																		rounded-full
																	"
																>
																	<span
																		class="
																			font-medium
																			leading-none
																			text-white
																			text-xs
																		"
																		>{{
																			form
																				.created_by_staff
																				?.profile_photo
																				?.default
																				?.initial
																		}}</span
																	>
																</span>
															</div>
															<div
																class="
																	ml-4
																	text-blue-600
																	font-semibold
																	truncate
																"
															>
																{{
																	form
																		.created_by_staff
																		.name
																}}
															</div>
														</div>
														<div
															v-if="
																form.inserted_at
															"
														>
															{{
																$filters.formatDateTime(
																	form.inserted_at
																)
															}}
														</div>
													</div>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-if="studentSelected && libSelected">
			<div
				class="
					flex
					items-center
					gap-4
					text-sm text-neutral-500
					font-semibold
					mb-6
				"
			>
				<div class="cursor-pointer" @click="libSelected = null">
					Biểu mẫu đánh giá
				</div>
				<img alt="" src="@/assets/images/icons/arrow-right.png" />
				<div>{{ studentSelected?.name }}</div>
			</div>
			<div v-if="isLoading">
				<Loading />
			</div>
			<div v-else>
				<div class="__report-lesson__header mb-8">
					<div class="flex flex-nowrap justify-between items-center">
						<div
							class="
								__record__title
								text-neutral-700
								font-semibold
								flex flex-nowrap
								items-center
								text-4xl
								gap-4
							"
						>
							<svg
								class="cursor-pointer"
								width="28"
								height="28"
								viewBox="0 0 28 28"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
								@click="libSelected = null"
							>
								<path
									d="M17.5 7L10.5 14L17.5 21"
									stroke="#94A3B8"
									stroke-width="2"
									stroke-linecap="round"
									stroke-linejoin="round"
								/>
							</svg>
							<img
								src="@/assets/images/icons/form-evaluation.png"
								alt=""
							/>
							<div>{{ formData?.name }}</div>
						</div>
						<button
							class="luca-button whitespace-nowrap"
							@click="copyAllGoal"
						>
							Thêm toàn bộ mục tiêu
						</button>
					</div>
				</div>
				<div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
					<div
						class="
							flex
							items-center
							justify-between
							bg-white
							py-4
							px-6
							rounded-lg
							shadow
						"
					>
						<div class="flex items-center gap-2">
							<img
								alt=""
								height="32"
								src="@/assets/images/icons/abc.png"
								style="height: 32px"
								width="32"
							/>
							<div class="text-neutral-500 text-sm">Lĩnh vực</div>
						</div>
						<div class="font-bold text-4xl text-neutral-600">
							{{ stats?.skill_count }}
						</div>
					</div>
					<div
						class="
							flex
							items-center
							justify-between
							bg-white
							py-4
							px-6
							rounded-lg
							shadow
						"
					>
						<div class="flex items-center gap-2">
							<img
								alt=""
								height="32"
								src="@/assets/images/icons/light.png"
								style="height: 32px"
								width="32"
							/>
							<div class="text-neutral-500 text-sm">Mục tiêu</div>
						</div>
						<div class="font-bold text-4xl text-neutral-600">
							{{ stats?.goal_count }}
						</div>
					</div>
				</div>
				<div v-for="(s, index) in skills" :key="index" class="mb-4">
					<div class="flex items-center justify-between mb-4">
						<div class="flex items-center">
							<div class="font-semibold text-neutral-700">
								{{ index + 1 }}. {{ s.skill?.name }} ({{
									s.goals.length
								}})
							</div>
						</div>
					</div>
					<div
						class="
							shadow-sm
							sm:rounded-2xl
							overflow-hidden
							md-down:hidden
						"
					>
						<div class="__record__table overflow-x-auto scroll-bar">
							<div
								class="
									overflow-hidden
									sm:rounded-t-2xl
									w-fit
									min-w-full
								"
							>
								<table
									class="min-w-full divide-y text-neutral-200"
								>
									<thead class="bg-neutral-100 h-16">
										<tr>
											<th
												class="
													px-4
													py-3
													text-center text-xs
													font-semibold
													text-neutral-600
													uppercase
													tracking-wider
													whitespace-nowrap
													w-16
												"
												scope="col"
											>
												STT
											</th>
											<th
												class="
													px-6
													py-3
													text-left text-xs
													font-semibold
													text-neutral-600
													uppercase
													tracking-wider
													whitespace-nowrap
												"
												scope="col"
											>
												Nội dung
											</th>
										</tr>
									</thead>
									<tbody>
										<tr
											v-for="(i, gIndex) in s.goals"
											:key="gIndex"
											:class="[
												gIndex % 2 === 0
													? 'bg-white'
													: 'bg-neutral-50',
											]"
											class="
												text-neutral-700
												hover:bg-orange-50
											"
										>
											<td
												class="
													p-4
													whitespace-nowrap
													text-neutral-700 text-center
												"
											>
												{{ gIndex + 1 }}
											</td>
											<td
												class="
													px-6
													py-4
													whitespace-nowrap
													text-neutral-700
												"
											>
												<div
													class="
														flex
														justify-between
														items-center
														gap-2
													"
												>
													<div class="w-full">
														<div
															class="
																flex
																items-center
																gap-2
															"
														>
															<div
																class="
																	whitespace-normal
																"
																v-html="
																	i.name ||
																	i.goal_name
																"
															></div>
														</div>
														<div
															class="
																flex
																gap-2
																flex-wrap
															"
															style="
																max-width: 360px;
															"
														>
															<template
																v-if="
																	i?.assistance_levels
																"
															>
																<div
																	v-for="ass in i?.assistance_levels"
																	:key="ass"
																	class="
																		flex
																		gap-2
																	"
																>
																	<div
																		class="
																			mt-1
																			py-0.5
																			px-2.5
																			rounded-full
																			bg-pink-100
																			whitespace-nowrap
																			text-neutral-700
																			h-fit
																			w-fit
																			font-semibold
																			shadow-input
																		"
																		style="
																			font-size: 10px;
																		"
																	>
																		{{
																			ass
																		}}
																	</div>
																</div>
															</template>
															<div
																class="
																	mt-1
																	py-0.5
																	px-2.5
																	rounded-full
																	bg-yellow-tag
																	text-neutral-700
																	h-fit
																	w-fit
																	font-semibold
																	shadow-input
																	whitespace-nowrap
																"
																style="
																	font-size: 10px;
																"
																v-if="i?.age"
															>
																{{ i?.age }}
															</div>
														</div>
														<div
															v-if="
																i.parent
																	?.sub_goal_count >
																0
															"
															class="
																goal-block
																flex
																gap-3
																mt-2
															"
														>
															<img
																class="
																	w-3
																	h-3
																	mt-1
																"
																src="@/assets/images/icons/goal-arrow.png"
																alt=""
															/>
															<div>
																<div
																	class="
																		text-neutral-700
																		whitespace-normal
																	"
																	v-html="
																		i.parent
																			?.name
																	"
																></div>
																<div
																	class="
																		text-neutral-400
																		text-xs
																		font-semibold
																	"
																>
																	{{
																		i.parent
																			?.sub_goal_count
																	}}
																	MỤC TIÊU
																</div>
															</div>
														</div>
													</div>
													<div
														v-if="
															goal_added.includes(
																i.library_item_id
															) || i.used === true
														"
														class="
															button-p
															btn--text
															whitespace-nowrap
															text-green-600
															w-max
															uppercase
														"
													>
														<svg
															class="mr-1"
															width="20"
															height="20"
															viewBox="0 0 20 20"
															fill="none"
															xmlns="http://www.w3.org/2000/svg"
														>
															<path
																fill-rule="evenodd"
																clip-rule="evenodd"
																d="M11.212 6.21209C11.5782 5.84597 12.1717 5.84597 12.5379 6.21209C12.8995 6.57371 12.9039 7.15727 12.5512 7.52434L7.56092 13.7622C7.55371 13.7712 7.54602 13.7798 7.53787 13.7879C7.17175 14.154 6.57816 14.154 6.21204 13.7879L2.90398 10.4799C2.53787 10.1137 2.53787 9.52015 2.90398 9.15403C3.2701 8.78791 3.86369 8.78791 4.22981 9.15403L6.84671 11.7709L11.1872 6.24013C11.1949 6.23029 11.2032 6.22093 11.212 6.21209Z"
																fill="#2AA797"
															/>
															<path
																fill-rule="evenodd"
																clip-rule="evenodd"
																d="M10.0615 12.6374L11.212 13.7879C11.5782 14.154 12.1718 14.154 12.5379 13.7879C12.546 13.7798 12.5537 13.7712 12.5609 13.7622L17.5512 7.52434C17.9039 7.15727 17.8995 6.57371 17.5379 6.21209C17.1717 5.84597 16.5782 5.84597 16.212 6.21209C16.2032 6.22093 16.1949 6.23029 16.1872 6.24013L11.8467 11.7709L11.24 11.1642L10.0615 12.6374Z"
																fill="#2AA797"
															/>
														</svg>
														<div
															class="
																text-green-600
															"
														>
															Đã thêm
														</div>
													</div>
													<div
														v-else
														class="
															text-yellow-600
															font-semibold
															text-xs
															whitespace-nowrap
															cursor-pointer
														"
														@click="doGoal(i)"
													>
														THÊM MT
													</div>
												</div>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
import {
	computed,
	ref,
	onBeforeUnmount,
	watch,
	onMounted,
	defineEmits,
	defineProps,
} from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { $api } from '@/services';
import Loading from '@/components/common/Loading';

const store = useStore();
const goal_added = computed(() => store.getters.goalAdded);
const emit = defineEmits(['success']);
const route = useRoute();
const students = ref([]);
const studentSelected = ref(null);
const isLoading = ref(false);
const disabled = ref(false);
const listForm = ref([]);
const libSelected = ref(null);
const formData = ref({});
const skills = ref([]);
const stats = ref({});

async function fetchStudent() {
	try {
		isLoading.value = true;
		const res = await $api.form.listStudentHaveForm();
		if (res?.data) {
			students.value =
				res?.data?.data.filter((s) => s.goal_count > 0) ?? [];
		}
		isLoading.value = false;
	} catch (e) {
		await store.dispatch('setAlertMessage', {
			message:
				e?.response?.data?.errors?.join('<br/>') ||
				'Đã có lỗi xảy ra. Vui lòng thử lại',
			type: 'danger',
		});
	}
}
function selectStudent(student) {
	studentSelected.value = student;
	fetchStudentForm();
}
async function fetchStudentForm() {
	try {
		isLoading.value = true;
		const res = await $api.form.listFormOfStudent(studentSelected.value.id);
		if (res?.data) {
			listForm.value = res?.data?.data ?? [];
		}
		isLoading.value = false;
	} catch (e) {
		await store.dispatch('setAlertMessage', {
			message:
				e?.response?.data?.errors?.join('<br/>') ||
				'Đã có lỗi xảy ra. Vui lòng thử lại',
			type: 'danger',
		});
	}
}

function selectLib(form_id) {
	libSelected.value = form_id;
	fetchStudentFormData();
}

async function fetchStudentFormData() {
	try {
		isLoading.value = true;
		const res = await $api.form.studentFormDetail(
			studentSelected.value.id,
			libSelected.value
		);
		formData.value = res.data.data;
		skills.value = res.data.skills;
		stats.value = res.data.stats;
		isLoading.value = false;
	} catch (err) {
		await store.dispatch('setAlertMessage', {
			message:
				err?.response?.data?.errors?.join('<br/>') ||
				'Đã có lỗi xảy ra. Vui lòng thử lại',
			type: 'danger',
		});
	}
}

async function doGoal(goal) {
	try {
		const res = await $api.form.copyGoalFromStudent(route.params.id, {
			goal_ids: [goal.id],
			state: 'assessment_form',
			student_assessment_form_id: Number(route.params.formId),
		});
		if (res.data) {
			store.dispatch('addGoal', goal.library_item_id);
			store.dispatch('setAlertMessage', {
				message: 'Sao chép mục tiêu thành công',
			});
			emit('success');
		}
	} catch (e) {
		await store.dispatch('setAlertMessage', {
			message:
				e?.response?.data?.errors?.join('<br/>') ||
				'Đã có lỗi xảy ra. Vui lòng thử lại',
			type: 'danger',
		});
	}
}

async function copyAllGoal() {
	try {
		const res = await $api.form.copyAllGoalFromStudentToStudent(
			route.params.id,
			route.params.formId,
			{
				from_student_assessment_form_id: libSelected.value,
				student_assessment_form_id: route.params.formId,
			}
		);
		if (res.data) {
			store.dispatch('setAlertMessage', {
				message: 'Sao chép mục tiêu thành công',
			});
			fetchStudentFormData();
			emit('success');
		}
	} catch (e) {
		await store.dispatch('setAlertMessage', {
			message:
				e?.response?.data?.errors?.join('<br/>') ||
				'Đã có lỗi xảy ra. Vui lòng thử lại',
			type: 'danger',
		});
	}
}

onMounted(() => {
	fetchStudent();
});
onBeforeUnmount(() => {
	store.dispatch('clearAdded');
});
</script>
